import { ApiMethods, ApiTags, appAPI } from '.';

export interface ContextItem {
  id: string;
  portalId: string;
  slug: string;
  itemType: string;
  title: string;
  content: string;
  templateVars?: string[];
  isDefault: boolean;
  version: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateContextItemInput {
  slug: string;
  itemType: string;
  title: string;
  content: string;
}

export interface UpdateContextItemInput {
  id: string;
  title?: string;
  content?: string;
}

export const contextItemApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    listContextItems: build.query<{ data: ContextItem[] }, void>({
      query: () => ({
        path: '/context-items',
        method: ApiMethods.get,
        options: {},
      }),
      providesTags: [{ type: ApiTags.contextItems, id: 'LIST' }],
    }),
    getContextItem: build.query<ContextItem, string>({
      query: (id) => ({
        path: `/context-items/${id}`,
        method: ApiMethods.get,
        options: {},
      }),
      providesTags: (_, __, id) => [{ type: ApiTags.contextItems, id }],
    }),
    createContextItem: build.mutation<ContextItem, CreateContextItemInput>({
      query: (body) => ({
        path: '/context-items',
        method: ApiMethods.post,
        options: { body },
      }),
      invalidatesTags: [{ type: ApiTags.contextItems, id: 'LIST' }],
    }),
    updateContextItem: build.mutation<ContextItem, UpdateContextItemInput>({
      query: ({ id, ...body }) => ({
        path: `/context-items/${id}`,
        method: ApiMethods.patch,
        options: { body },
      }),
      invalidatesTags: (_, __, { id }) => [
        { type: ApiTags.contextItems, id: 'LIST' },
        { type: ApiTags.contextItems, id },
      ],
    }),
    deleteContextItem: build.mutation<void, string>({
      query: (id) => ({
        path: `/context-items/${id}`,
        method: ApiMethods.del,
        options: {},
      }),
      invalidatesTags: (_, __, id) => [
        { type: ApiTags.contextItems, id: 'LIST' },
        { type: ApiTags.contextItems, id },
      ],
    }),
  }),
});

export const {
  useListContextItemsQuery,
  useGetContextItemQuery,
  useCreateContextItemMutation,
  useUpdateContextItemMutation,
  useDeleteContextItemMutation,
} = contextItemApi;
